import { createSlice } from '@reduxjs/toolkit';
// utils
import CaseService from '../../services/case';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  Cases: [],
  CaseList: []
};

const slice = createSlice({
  name: 'Case',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET MANAGE Cases
    getCaseListSuccess(state, action) {
      state.isLoading = false;
      state.CaseList = action.payload.listData || [];
      state.totalCount = action.payload.totalCount || 0;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { onToggleFollow, deleteCase } = slice.actions;

// ----------------------------------------------------------------------

export function getCaseList(query = {}) {
  return async (dispatch) => {
    Object.keys(query).forEach((key) => {
      if (!query[key] || query[key] === '' || query[key] === 'all') {
        delete query[key];
      }
    });
    dispatch(slice.actions.startLoading());
    try {
      const response = await CaseService.getList(query);
      dispatch(slice.actions.getCaseListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
